import React from 'react';
import { processSteps } from '../data/content';
import { Reveal } from './Reveal';
export function Process() {
  return <section className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32" data-id="element-91" data-mp="1ucahlimd5e3p">
      <Reveal className="max-w-2xl" data-id="element-92" data-mp="1yep2e89lenxm">
        <p className="text-[13px] font-medium uppercase tracking-[0.16em] text-accent" data-id="element-93" data-mp="1yfqaq4z84wbn">Proceso</p>
        <h2 className="mt-4 text-4xl font-semibold leading-[1.1] tracking-[-0.03em] text-ink lg:text-5xl" data-id="element-94" data-mp="23drvqvg7n5pr">
          Cómo trabajamos
        </h2>
        <p className="mt-5 text-lg leading-relaxed text-ink-soft" data-id="element-95" data-mp="1apctzam3ajwd">
          Cinco etapas simples, con entregables visibles en cada una para que siempre sepas dónde
          está tu proyecto.
        </p>
      </Reveal>

      <ol className="relative mt-16 grid gap-10 md:grid-cols-3 lg:grid-cols-5 lg:gap-6" data-id="element-96" data-mp="1kfpamrqs9sx8">
        <div aria-hidden="true" className="absolute left-0 right-0 top-5 hidden h-px bg-gradient-to-r from-transparent via-slate-300 to-transparent lg:block" data-id="element-97" data-mp="n0l78yr9qtqz" />
        {processSteps.map((step, i) => <li key={step.title} className="relative" data-id="element-98" data-mp="19jxvzl601oen" data-mpi={i}>
            <Reveal delay={i * 0.09} data-id="element-99" data-mp="15jw2w0eby3az">
              <span className="relative z-10 inline-flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 bg-white text-sm font-semibold text-ink shadow-soft" data-id="element-100" data-mp="15kxeq7366ttr">
                {i + 1}
              </span>
              <h3 className="mt-5 text-base font-semibold tracking-[-0.01em] text-ink" data-id="element-101" data-mp="vrqd8xbjvxyy">
                {step.title}
              </h3>
              <p className="mt-2 text-[15px] leading-relaxed text-ink-soft" data-id="element-102" data-mp="lvwtotzez47o">{step.description}</p>
            </Reveal>
          </li>)}
      </ol>
    </section>;
}